if (typeof global !== 'undefined' && typeof CustomEvent === 'undefined') {
  // eslint-disable-next-line
  // @ts-ignore-next-line
  global.CustomEvent = class CustomEvent {};
}
